// shared-components/hooks/useWebsite.ts
import { useContext } from "react";
import { WebsiteContext } from "../context/WebsiteContextDefinition";
import type { WebsiteContextValue } from "../types/WebsiteTypes";

// Hook for consuming the context
export const useWebsite = (): WebsiteContextValue => {
  const context = useContext(WebsiteContext);
  if (context === null) {
    throw new Error("useWebsite must be used within a WebsiteProvider");
  }
  return context;
};
